import { LayoutOne } from "@/layouts";
import Contact from "@/components/contact";
import FaqSection from "@/components/faq";
import OurGroupSection from "@/components/ourGroup";
import SeoHead from "@/components/SeoHead";
import contactFaq from "@/data/faq/contact";
import { CONTACT_SCHEMA } from "@/lib/contactSchema";

function ContactUs() {
  return (
    <>
      <SeoHead
        path="/contact"
        fallbackTitle="Contact Siddhivinayak Group | Site Visit Nagpur"
        fallbackDescription="Contact Siddhivinayak Group for site visits, pricing, and project enquiries. Call +91 98232 60303 or visit our office at Raje Raghuji Nagar, Nagpur 440009."
        seo={{
          seo_title: "Contact Siddhivinayak Group | Site Visit Nagpur",
          meta_description: "Contact Siddhivinayak Group for site visits, pricing, and project enquiries. Call +91 98232 60303 or visit our office at Raje Raghuji Nagar, Nagpur 440009.",
          focus_keyword: "contact Siddhivinayak Group Nagpur",
          secondary_keywords: [
            "book site visit Nagpur",
            "real estate developer contact Nagpur",
            "Hilltop Heights site visit",
            "Ayodhya City enquiry",
            "Siddhivinayak Nagari RL plots contact",
            "property enquiry Nagpur phone",
            "Kunal Padole Group office Nagpur",
          ],
          canonical_url: "",
          schema_json: CONTACT_SCHEMA,
          og_image: "/img/og/siddhivinayak-group-og.jpg",
          og_title: "Contact Siddhivinayak Group | Site Visit Nagpur",
          og_description: "Book a free site visit or enquire about any Siddhivinayak Group project. Phone, email, and walk-in options available across Nagpur.",
        }}
        publisherName="Siddhivinayak Group"
        speakable_selectors={[
          ".section-title",
          ".faq-question",
          ".contact-form-card__title",
        ]}
      />
      <LayoutOne topbar={true}>
        <Contact />
        <FaqSection
          sectionSpace="pt-115 pb-90"
          faqData={contactFaq}
          subTitle="Contact & Enquiries"
          title="Frequently Asked Questions"
          intro="Answers to common questions about contacting Siddhivinayak Group, booking a site visit, and what to expect during your first interaction in Nagpur."
        />
        <div className="section-bg-1">
          <OurGroupSection />
        </div>
      </LayoutOne>
    </>
  );
}

export default ContactUs;